import { render } from "./View.vue?vue&type=template&id=2c1d3e52"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"

import exportComponent from "/Users/imac/projects/java/marketplace/wallet/wallet.console.web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__